import _ from 'underscore';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import cx from 'classnames';

import Section from 'components/Section';
import Slider from 'components/sliders/OffsetSlider';

import CommonPropTypes from 'utils/propTypes/common';

import styles from './styles.module.scss';

const RecommendationsSlider = ({
	title,
	markupBlocks,
	entities,
	renderCard,
	setActiveEntity,
	activeEntity,
	clickBehavior,
	setShowVideo,
	...props
}) => {
	const [swiper, setSwiper] = useState(null);

	const listRef = useRef(null);

	useEffect(() => {
		if (swiper && !swiper.destroyed) {
			const entityIndex = _(entities).findIndex({ _id: activeEntity._id });

			swiper.slideTo(entityIndex);
		}
	}, [activeEntity, swiper]);

	const onCardClick = useCallback(
		(entityId) => {
			const entityIndex = _(entities).findIndex({ _id: entityId });
			setActiveEntity(entities[entityIndex]);
			if (setShowVideo) {
				setShowVideo(false);
			}
		},
		[entities]
	);

	return (
		<div className={styles.list} ref={listRef}>
			<Section title={title} markupBlocks={markupBlocks} {...props}>
				<Slider
					withNavigation
					getSwiper={setSwiper}
					theme="preview"
					paginationMarkupAttributes={markupBlocks.pagination}
				>
					{_(entities).map((entity) => (
						<VisibilitySensor key={entity._id} containment={listRef.current}>
							{({ isVisible, visibilityRect }) => {
								const cardCx = cx(styles.card, {
									[styles.visible]:
										!_.isBoolean(isVisible) ||
										(visibilityRect.left && visibilityRect.right),
									[styles.active]: entity._id === activeEntity._id
								});

								return (
									<div className={cardCx}>
										<div className={styles.inner}>
											{renderCard(
												entity,
												clickBehavior === 'preview' ? onCardClick : null
											)}
										</div>
									</div>
								);
							}}
						</VisibilitySensor>
					))}
				</Slider>
			</Section>
		</div>
	);
};

RecommendationsSlider.propTypes = {
	entities: CommonPropTypes.entities.isRequired,
	activeEntity: CommonPropTypes.entity,
	setActiveEntity: PropTypes.func,
	title: PropTypes.string,
	markupBlocks: PropTypes.object,
	renderCard: PropTypes.func.isRequired,
	clickBehavior: PropTypes.oneOf(['link', 'preview']),
	setShowVideo: PropTypes.func
};

RecommendationsSlider.defaultProps = {
	title: 'Выбор редакции',
	markupBlocks: {},
	clickBehavior: 'preview'
};

export default RecommendationsSlider;
